const INITIAL_STATE = {};

export default function (state = INITIAL_STATE) {
    return state;
}
